module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_15",
    attrs: {
      "id": "calibre_pb_16"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('a', {
    staticClass: "calibre8"
  }), _vm._v("WORK AND PLAY")])]), _vm._v(" "), _c('h2', {
    staticClass: "calibre_22",
    attrs: {
      "id": "filepos59565"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("1 "), _c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "image",
      "src": "images/00004.jpg"
    }
  }), _vm._v(" Revaluation of Values: Three False Values")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("1. Karma (“Action”) must surely be active, not passive. It is not ours, rather we are its. We are corks in a turbulent eddying stream of karma; karma is the force-field to which we are subject on the plane of phenomena.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("2. The “I,” “Me,” “Self,” whatever term we encounter or use to describe our reality, is misleading. All these terms suggest a being, yet the Buddha stated again and again in the Diamond Sutra that there is no such being.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Our reality is a state, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("l’etat sans ego,")]), _vm._v(" a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("state")]), _vm._v(" not a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("person")]), _vm._v(", the I-less state. It is always present, and it alone is present.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("3. The “me,” “ego,” “self,” “personality,” the personal pronoun “I” as we use it every moment in thought and word, is just a mistake, an error of judgement, like a shadow mistaken for its substance on a moonlight night. Though there could be no shadow if there were no substance, nevertheless the shadow remains unreal (unsubstantial)—and when the moon is hidden by a cloud the shadow no longer exists.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Every time we say “I” we are making a mistake, mistaking something that isn’t there for something that is. Every such time the I-less state has been misinterpreted as something personal.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("If we were to perceive the shadow as such, and thereby recognise its substance, the I-less state for what it is, the whole “cave of illusions” would collapse and vanish for ever. Reality would lie naked before us—and we should be it.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Yet expression of the I-less state takes the form “I am” on the plane of dualism, but no qualification is possible: it is the “I am that I am” of the Bible which may be described as a "), _c('a'), _vm._v("personal expression of the Impersonal. Rather is it just “Am,” i.e. Consciousness.")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3019f30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_011.vue
// module id = 93
// module chunks = 0